import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { Card, Form, Input } from 'antd'

const FormItem = Form.Item

const ProfileContactStep = ({ form, profile, profileContactData }) => {
  const { getFieldDecorator } = form

  if (isEmpty(profileContactData)) {
    return (
      <React.Fragment>
        <Card title="Profile" type="inner">
          <FormItem
            label="Name"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
          >
            {getFieldDecorator('name', {
              rules: [
                {
                  message: 'Please input your name!',
                },
              ],
            })(<Input placeholder="Enter name" />)}
          </FormItem>
          <FormItem
            label="Nationality(ies)"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
          >
            {getFieldDecorator(
              'nationality',
              {}
            )(<Input placeholder="Enter nationality or nationalities" />)}
          </FormItem>
          <FormItem
            label="Qualifications"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
          >
            {getFieldDecorator(
              'qualification',
              {}
            )(<Input placeholder="Enter qualifications" />)}
          </FormItem>
          <FormItem
            label="Years of Experience"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
          >
            {getFieldDecorator(
              'yearsofexperience',
              {}
            )(<Input placeholder="Enter years of experience" />)}
          </FormItem>
          <FormItem
            label="Countries of Experience"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
          >
            {getFieldDecorator(
              'countryofexperience',
              {}
            )(
              <Input placeholder="Enter countries of experience separated by commas" />
            )}
          </FormItem>
        </Card>
        <Card title="Contacts" type="inner">
          <FormItem
            label="Phone"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            {getFieldDecorator(
              'phone',
              {}
            )(<Input placeholder="Enter phone number" />)}
          </FormItem>
          <FormItem
            label="Email"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            {getFieldDecorator('email', {
              rules: [
                {
                  type: 'email',
                  message: 'The input is not a valid email!',
                },
                {
                  required: true,
                  message: 'Please input your email!',
                },
              ],
            })(<Input placeholder="Enter email address" />)}
          </FormItem>
          <FormItem
            label="Location"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            {getFieldDecorator(
              'location',
              {}
            )(<Input placeholder="Enter current location" />)}
          </FormItem>
        </Card>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Card title="Profile" type="inner">
        <FormItem label="Name" labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
          {getFieldDecorator('name', {
            initialValue: profileContactData.name
              ? profileContactData.name
              : '',
            rules: [
              {
                required: true,
                message: 'Please input your name!',
              },
            ],
          })(<Input placeholder="Enter name" />)}
        </FormItem>
        <FormItem
          label="Nationality(ies)"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
        >
          {getFieldDecorator('nationality', {
            initialValue: profileContactData.nationality
              ? profileContactData.nationality
              : '',
          })(<Input placeholder="Enter nationality or nationalities" />)}
        </FormItem>
        <FormItem
          label="Qualifications"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
        >
          {getFieldDecorator('qualification', {
            initialValue: profileContactData.qualification
              ? profileContactData.qualification
              : '',
          })(<Input placeholder="Enter qualifications" />)}
        </FormItem>
        <FormItem
          label="Years of Experience"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
        >
          {getFieldDecorator('yearsofexperience', {
            initialValue: profileContactData.yearsofexperience
              ? profileContactData.yearsofexperience
              : '',
          })(<Input placeholder="Enter years of experience" />)}
        </FormItem>
        <FormItem
          label="Countries of Experience"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
        >
          {getFieldDecorator('countryofexperience', {
            initialValue: profileContactData.countryofexperience
              ? profileContactData.countryofexperience
              : '',
          })(
            <Input placeholder="Enter countries of experience separated by commas" />
          )}
        </FormItem>
      </Card>
      <Card title="Contacts" type="inner">
        <FormItem
          label="Phone"
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 22 }}
        >
          {getFieldDecorator('phone', {
            initialValue: profileContactData.phone
              ? profileContactData.phone
              : '',
          })(<Input placeholder="Enter phone number" />)}
        </FormItem>
        <FormItem
          label="Email"
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 22 }}
        >
          {getFieldDecorator('email', {
            initialValue: profileContactData.email
              ? profileContactData.email
              : '',
            rules: [
              {
                type: 'email',
                message: 'The input is not a valid email!',
              },
              {
                required: true,
                message: 'Please input your email!',
              },
            ],
          })(<Input placeholder="Enter email address" />)}
        </FormItem>
        <FormItem
          label="Location"
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 22 }}
        >
          {getFieldDecorator('location', {
            initialValue: profileContactData.location
              ? profileContactData.location
              : '',
          })(<Input placeholder="Enter current location" />)}
        </FormItem>
      </Card>
    </React.Fragment>
  )
}

export default ProfileContactStep
